export const DEFAULT_COLOR = '#d58936';